var render = function (_h,_vm) {var _c=_vm._c;return _c('h3',{staticClass:"pr-2",staticStyle:{"padding-top":"0.15em"}},[_c('router-link',{attrs:{"to":_vm.props.to}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }